import api from './client';
import type {
  PedidosFilters,
  PedidosResponse,
  ProdutosPedidoResponse,
  ContasReceberResponse
} from '../types/pedidos';

class PedidosApi {
  // Monta querystring repetindo filtroEmpresas pra ASP.NET bindar como List<string>.
  private buildParams(filters?: PedidosFilters): URLSearchParams {
    const params = new URLSearchParams();
    if (filters?.filtroCliente) params.append('filtroCliente', filters.filtroCliente);
    if (filters?.filtroVendedor) params.append('filtroVendedor', filters.filtroVendedor);
    if (filters?.filtroStatus) params.append('filtroStatus', filters.filtroStatus);
    if (filters?.filtroEmpresas?.length) {
      filters.filtroEmpresas.forEach(e => params.append('filtroEmpresas', e));
    }
    return params;
  }

  async getPedidosPorRegiao(filters?: PedidosFilters) {
    const qs = this.buildParams(filters).toString();
    return api.get<PedidosResponse>(`/pedidos/regiao${qs ? `?${qs}` : ''}`);
  }

  async getPedidosPorRota(filters?: PedidosFilters) {
    const qs = this.buildParams(filters).toString();
    return api.get<PedidosResponse>(`/pedidos/rota${qs ? `?${qs}` : ''}`);
  }

  // empresa vem do pedido clicado — ERP tem PK composta (empresa, pedido).
  async getProdutosPedido(pedidoCodigo: string, empresa?: string) {
    const qs = empresa ? `?empresa=${encodeURIComponent(empresa)}` : '';
    return api.get<ProdutosPedidoResponse>(`/pedidos/${pedidoCodigo}/produtos${qs}`);
  }

  async getContasReceber(clienteCodigo: string) {
    return api.get<ContasReceberResponse>(`/pedidos/contas-receber/${clienteCodigo}`);
  }
}

export const pedidosApi = new PedidosApi();
